import { isIOSDevice } from './responsive';

export const getPathFromLaunchUrl = launchURL =>
  launchURL.replace('approvals:/', '');

export const subscribeToNotifications = () => {
  if (
    isIOSDevice() &&
    window?.cordova?.plugins &&
    window.cordova.plugins.OpenAppSettings
  ) {
    window.cordova.plugins.OpenAppSettings.open();
  } else if (!isIOSDevice()) {
    window.OneSignal.push(() => {
      window.OneSignal.showSlidedownPrompt({ force: true });
    });
  }
};
